import { render, staticRenderFns } from "./SingleSuggestInput.vue?vue&type=template&id=0d243d08&scoped=true&"
import script from "./SingleSuggestInput.vue?vue&type=script&lang=js&"
export * from "./SingleSuggestInput.vue?vue&type=script&lang=js&"
import style0 from "./SingleSuggestInput.vue?vue&type=style&index=0&id=0d243d08&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d243d08",
  null
  
)

export default component.exports